module.exports = __webpack_public_path__ + "static/media/checkmark_green.c87194c8.svg";